import { Platform } from 'react-native'

import { UploadFileProps } from 'app/components/fields/UploadFields/UploadField/UploadField.types'
import Api from 'app/services/Api'
import {
  getFilePayload,
  putUploadFile
} from 'app/utils/helpers/activeStorage.helpers'

export type DirectUploadResponse = {
  signed_id?: string
  awsUrl?: string
  url?: string
}

/**
 * Direct upload helper
 */
const directUpload = async ({
  file,
  url: uri = '',
  bucket
}: UploadFileProps): Promise<DirectUploadResponse> => {
  try {
    const isWeb = Platform.OS === 'web'
    const filePayload = await getFilePayload({ file, uri })

    const {
      direct_upload: { url, headers },
      signed_id
    } = await Api.post('/rails/active_storage/direct_uploads', {
      data: {
        blob: {
          filename: filePayload.name,
          byte_size: filePayload.size,
          content_type: filePayload.type,
          checksum: filePayload.checksum
        },
        ...(bucket && {
          bucket
        })
      }
    })

    await putUploadFile({ url, uri, file, headers })

    if (isWeb) {
      // FIXME: generated image url for preview in the form field for heic format but now it's work for all formats
      const imageUrl = `${
        process.env.NEXT_PUBLIC_API
      }/rails/active_storage/blobs/redirect/${signed_id}/${encodeURIComponent(
        filePayload.name
      )}`

      return { signed_id: signed_id, url: imageUrl }
    }

    return { signed_id: signed_id }
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Direct upload of one file
 */
export const directUploadOne = (
  file: UploadFileProps
): Promise<DirectUploadResponse> => {
  return directUpload(file)
}

/**
 * Direct upload of all files
 */
export const directUploadAll = (
  files: UploadFileProps[]
): Promise<DirectUploadResponse[]> => {
  return Promise.all(files.map((file: UploadFileProps) => directUpload(file)))
}
